import Button from '@/components/atoms/Button'
import Container from '@/components/atoms/Container'
import libraryService from '@/services/libraryService'
import { useAppSelector } from '@/store/hooks'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

export function Body() {
	const {
		matriculate: { classSelect },
		auth: { user },
	} = useAppSelector((state) => state)

	const navigate = useNavigate()

	const findOnboarding = user?.onboarding_all?.find(
		(onboarding) => onboarding.curso_id === classSelect?.curso_id
	)

	if (!findOnboarding?.proficiencia_id) {
		navigate('/curso')
		return null // Impede execução adicional se `proficiencia_id` não estiver presente.
	}

	const { data: proficiencyData } = libraryService.getProficiency()

	const nivelamentos = proficiencyData?.find(
		(item) => item.id === findOnboarding.proficiencia_id
	)?.nivel

	// Mapeamento direto dos textos com base nos IDs de proficiência.
	const infoBoxMapping: Record<1 | 2 | 3 | 4 | 34 | 35 | 36 | 37, string> = {
		1: `<b>Welcome to your English learning journey!</b> Inicie sua jornada de aprendizado do inglês dando os primeiros passos com saudações, vocabulário e estruturas básicas para se comunicar no cotidiano.`,
		2: `<b>Start strong with the Basic of English!</b> No nível <b>${nivelamentos || ''}</b>, você vai fortalecer as bases do inglês e praticar todas as estruturas essenciais pra ir muito longe no seu aprendizado!`,
		3: `<b>You’re ready to intermediate your English skills!</b> No nível <b>${nivelamentos || ''}</b>, você vai avançar para um uso mais avançado do inglês. Aprofunde-se em textos e mídias complexas e participe de conversas sobre diversos temas com maior fluência.`,
		4: `<b>Unlock the secrets of fluency and become an Independent!</b> In the <b>${nivelamentos || ''}</b> module, you will be challenged to deepen your mastery of the English language. You will conquer complexity, master nuance and be ready to use English in professional and academic contexts.`,
		34: `<b>¡Bienvenido a tu viaje de aprendizaje de español!</b> Inicie sua jornada de aprendizado do espanhol dando os primeiros passos com saudações, vocabulário e estruturas básicas para se comunicar no cotidiano.`,
		35: `<b>¡Empieza fuerte con el básico de Español!</b> No nível <b>${nivelamentos || ''}</b>, você vai fortalecer as bases do espanhol e praticar todas as estruturas essenciais pra ir muito longe no seu aprendizado!`,
		36: `<b>¡Estás listo para elevar aún más tus habilidades en Español!</b> En el nivel <b>${nivelamentos || ''}</b>, progresarás hacia un uso más avanzado del Español. Te profundizarás en textos y medios complejos y participarás en conversaciones sobre diversos temas con mayor fluidez.`,
		37: `<b>¡Desbloquea los secretos de la fluidez y conviértete en un experto!</b> En el módulo <b>${nivelamentos || ''}</b>, te desafiarás a profundizar tu dominio del idioma Español. Conquistarás la complejidad, dominarás los matices y estarás listo para usar el Español en contextos profesionales y académicos.`,
	}

	// Obtém o texto correspondente ao nível ou um valor padrão.
	const infoBox =
		infoBoxMapping[
			findOnboarding.proficiencia_id as keyof typeof infoBoxMapping
		] || ''

	return (
		<Container className='flex flex-col items-center justify-between min-h-[84vh] gap-10'>
			<img
				src='/imgs/admin/success/you-rock.png'
				alt='Emoji'
				className='w-[70%] -mt-10 md:w-auto h-auto'
			/>

			<h1 className='text-3xl lg:text-4xl text-white font-bold leading-[120%] -mt-20 relative text-center z-20'>
				Você vai começar a jornada no
				<br />
				<span
					style={{
						textShadow: `4px 4px 0px rgba(248, 164, 199, 1),
						2px 2px 0px rgba(242, 51, 130, 1),
						1px 1px 0px rgba(116, 8, 52, 1)`,
					}}
					className='relative text-5xl lg:text-9xl z-0 text-brand-primary uppercase'
				>
					{nivelamentos}
				</span>
			</h1>

			<div
				className={twMerge(
					'w-full max-w-[680px] flex flex-col p-5 gap-8 rounded-md bg-[#231830]',
					classNames({ 'bg-[#231830]/0 items-center': !infoBox })
				)}
			>
				{infoBox && nivelamentos && (
					<div className='flex flex-col gap-3'>
						<>
							<span className='text-lg text-white font-bold'>
								Oba, mas o que isso significa?
							</span>

							<p
								className='text-white leading-5'
								dangerouslySetInnerHTML={{ __html: infoBox }}
							/>
						</>
					</div>
				)}
				<Button
					type='button'
					className='w-full max-w-[210px] bg-transparent hover:bg-white/5 border border-solid rounded-full h-[40px]'
					onClick={() => navigate('/curso')}
				>
					Começar Jornada
				</Button>
			</div>
		</Container>
	)
}
